import React from 'react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { trackEvent } from '@/lib/analytics';
const ForecastSelector = ({
  forecastHours,
  setForecastHours
}) => {
  const handleForecastSelection = hours => {
    setForecastHours(hours);
    // Google Analytics tracking event
    trackEvent('forecast_selection', { value: hours, content_type: 'forecast', item_id: `${hours}h` });
  };
  const getButtonText = () => {
    if (forecastHours === -24) {
      return 'Yesterday';
    } else if (forecastHours === 0) {
      return `Now 🔮`;
    } else {
      return `In ${forecastHours}h 🔮`;
    }
  };
  return <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="bg-gray-100 hover:bg-gray-200 text-gray-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200" onClick={() => {
        trackEvent('forecast_button_click', { content_type: 'forecast', item_id: 'In - forecast button' });
      }}>
          {getButtonText()}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-lg z-50 rounded-3xl">
        <DropdownMenuItem onClick={() => handleForecastSelection(0)} className="rounded-full">Now 🔮</DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleForecastSelection(3)}>In 3 hours</DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleForecastSelection(6)}>In 6 hours</DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleForecastSelection(12)}>In 12 hours</DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleForecastSelection(-24)}>Yesterday</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>;
};
export default ForecastSelector;